import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, RadioGroup, FormControlLabel, Radio, Button } from '@material-ui/core';
import { clone, newId, timeFormat2 } from '../../../../../common/utils';
import { ADD, EDIT, ERR, globalData, SPOUSE, TEXT, VIEW } from '../../../../../common/common';

const Root = styled(Box)({
    width: '100%',
})

class PanelSpouse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                "S.F.Name": "",
                "S.L.Name": "",
                "S.DOB": new Date(),
                "S.SSN.L4": "",
                "S.H.Pho": "",
                "S.W.Pho": "",
                "S.Em": "",
                "S.F.L.N.I.": "",
                "S.H.Addr.": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
            },
            stateData: ["CN", "US"],
            panelState: ADD,
            showMsg: false
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const {
            data,
            panelState,
            stateData
        } = this.state;
        const content = () => {
            if (panelState === VIEW) {
                return spouseView()
            } else if (panelState === EDIT || panelState === ADD) {
                return spouseEdit()
            }
        }
        const spouseView = () => {
            return <div className="panel-wapper v v-r">
                <div className="flow">
                    <div className="text-wapper">
                        <div className="text-title">Spouse Full Legal Name</div>
                        <div>{data["S.F.Name"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Last Name</div>
                        <div>{data["S.L.Name"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Initial Name</div>
                        <div>{data["S.F.L.N.I."]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Date of Birth</div>
                        <div>{data["S.DOB"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Last 4 Digits of Spouse Social Security Number</div>
                        <div>{data["S.SSN.L4"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Choose The Country</div>
                        <div>{data["S.H.Addr."]["country"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Street</div>
                        <div>{data["S.H.Addr."]["street"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse City</div>
                        <div>{data["S.H.Addr."]["city"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse State</div>
                        <div>{data["S.H.Addr."]["state"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Zip Code</div>
                        <div>{data["S.H.Addr."]["zipcode"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Home Phone</div>
                        <div>{data["S.H.Pho"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Work Phone (Optional)</div>
                        <div>{data["S.W.Pho"]}</div>
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Email (Optional)</div>
                        <div>{data["S.Em"]}</div>
                    </div>
                </div>
                <div>
                    <Button size="small" color="primary" onClick={this.handleEdit}>Edit</Button>
                </div>
            </div>
        }
        const spouseEdit = () => {
            return <div className="panel-wapper v v-r">
                <div className="flow">
                    <div className="text-wapper">
                        <div className="text-title">Spouse Full Legal Name</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.F.Name"]}
                            onChange={e => this.handleChange(e, 'S.F.Name')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.F.Name")}
                            helperText={this.validator(TEXT, "S.F.Name")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Last Name</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.L.Name"]}
                            onChange={e => this.handleChange(e, 'S.L.Name')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.L.Name")}
                            helperText={this.validator(TEXT, "S.L.Name")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Initial Name</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.F.L.N.I."]}
                            onChange={e => this.handleChange(e, 'S.F.L.N.I.')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.F.L.N.I.")}
                            helperText={this.validator(TEXT, "S.F.L.N.I.")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Date of Birth</div>
                        <TextField
                            type="date"
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.DOB"]}
                            onChange={e => this.handleChange(e, 'S.DOB')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.DOB")}
                            helperText={this.validator(TEXT, "S.DOB")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Last 4 Digits of Spouse Social Security Number</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.SSN.L4"]}
                            onChange={e => this.handleChange(e, 'S.SSN.L4')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.SSN.L4")}
                            helperText={this.validator(TEXT, "S.SSN.L4")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Choose The Country</div>
                        <TextField
                            disabled={this.isDisabled()}
                            select
                            className="text-field"
                            value={data["S.H.Addr."]["country"]}
                            onChange={e => this.handleChange(e, 'country', "S.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.H.Addr.", "country")}
                            helperText={this.validator(TEXT, "S.H.Addr.", "country")}
                        >
                            {stateData.map((row, index) => (
                                <MenuItem key={index} value={row}>
                                    {row}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                    {unitView("S.H.Addr.")}
                    <div className="text-wapper">
                        <div className="text-title">Spouse Street</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.H.Addr."]["street"]}
                            onChange={e => this.handleChange(e, 'street', "S.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.H.Addr.", "street")}
                            helperText={this.validator(TEXT, "S.H.Addr.", "street")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse City</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.H.Addr."]["city"]}
                            onChange={e => this.handleChange(e, 'city', "S.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.H.Addr.", "city")}
                            helperText={this.validator(TEXT, "S.H.Addr.", "city")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse State</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.H.Addr."]["state"]}
                            onChange={e => this.handleChange(e, 'state', "S.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.H.Addr.", "state")}
                            helperText={this.validator(TEXT, "S.H.Addr.", "state")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Zip Code</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.H.Addr."]["zipcode"]}
                            onChange={e => this.handleChange(e, 'zipcode', "S.H.Addr.")}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.H.Addr.", "zipcode")}
                            helperText={this.validator(TEXT, "S.H.Addr.", "zipcode")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Home Phone</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.H.Pho"]}
                            onChange={e => this.handleChange(e, 'S.H.Pho')}
                            margin="dense"
                            variant="outlined"
                            error={this.validator(ERR, "S.H.Pho")}
                            helperText={this.validator(TEXT, "S.H.Pho")}
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Work Phone (Optional)</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.W.Pho"]}
                            onChange={e => this.handleChange(e, 'S.W.Pho')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                    <div className="text-wapper">
                        <div className="text-title">Spouse Email (Optional)</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={data["S.Em"]}
                            onChange={e => this.handleChange(e, 'S.Em')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div>
                </div>
            </div>
        }
        const unitView = (key) => {
            if (data[key]["country"] === "CN") {
                return <div className="text-wapper">
                    <div className="text-title">Principal Unit</div>
                    <TextField
                        disabled={this.isDisabled()}
                        className="text-field"
                        value={data[key]["unit"]}
                        onChange={e => this.handleChange(e, 'unit', key)}
                        margin="dense"
                        variant="outlined"
                        error={this.validator(ERR, key, "unit")}
                        helperText={this.validator(TEXT, key, "unit")}
                    />
                </div>
            }
        }
        return (
            <Root>
                {content()}
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    componentDidUpdate(prevProps) {
        if (this.props.dataINFO !== prevProps.dataINFO) {
            const data = this.props.dataINFO;
            if (data && this.props.isAdd) {
                data["S.DOB"] = timeFormat2(data["S.DOB"]);
                let panelState = ADD;
                this.setState(() => ({
                    data,
                    panelState
                }))
            }
        }
    }
    initData() {
        const { dataINFO, isAdd } = this.props;
        let data = {};
        let panelState = "";
        if (isAdd) {
            panelState = ADD;
            data = {
                "S.F.Name": "",
                "S.L.Name": "",
                "S.DOB": timeFormat2(new Date()),
                "S.SSN.L4": "",
                "S.H.Pho": "",
                "S.W.Pho": "",
                "S.Em": "",
                "S.F.L.N.I.": "",
                "S.H.Addr.": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
                "type": SPOUSE
            }
        } else {
            panelState = EDIT;
            data = dataINFO ? clone(dataINFO) : globalData.dataINFO;
            data["S.DOB"] = timeFormat2(data["S.DOB"]);
        }
        this.setState(() => ({
            data,
            panelState
        }))
    }
    handleAdd() {
        this.setState({
            panelState: EDIT
        })
    }
    handleEdit() {
        this.setState({
            panelState: EDIT
        })
    }
    handleSave(callback = null) {
        const { data } = this.state;
        const { isAdd } = this.props;
        this.setState({
            showMsg: true
        }, () => {
            if (this.doNext()) {
                if (callback) callback(true);
                this.setState({
                    panelState: VIEW
                })
                this.extractSpouseToGlobal(data)
                this.props.updateInfoData(data, isAdd);
            } else {
                if (callback) callback(false);
            }
        })
    }
    handleCancel() {
        this.setState({
            panelState: VIEW
        })
    }
    extractSpouseToGlobal(infoData) {
        console.log(infoData)
        const spouseInfo = {};
        spouseInfo[".CHO.Em"] = infoData["S.Em"];
        spouseInfo[".CHO.N."] = infoData["S.F.Name"];
        spouseInfo[".CHO.AddrNPho"] = infoData["S.H.Addr."];
        spouseInfo[".CHO.Addr"] = infoData["S.H.Addr."];
        spouseInfo["S.H.Pho"] = infoData["S.H.Pho"];
        spouseInfo["S.W.Pho"] = infoData["S.W.Pho"];
        spouseInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Client's;Wife" : "Client's;Husband";
        spouseInfo["rc"] = "Client's";
        spouseInfo["relation"] = (infoData["P.SEX"] === "male") ? "Wife" : "Husband";
        spouseInfo["type"] = SPOUSE;
        globalData.spouseInfo = spouseInfo;
    }
    handleChange(e, name, addrKey) {
        const value = e.target.value;
        const { data } = this.state;
        data[name] = value;
        if (name === "phone" || name === "unit"
            || name === "street" || name === "city"
            || name === "country" || name === "state"
            || name === "zipcode") {
            data[addrKey][name] = value;
        } else if (name === "P.H.Pho") {
            data["P.H.Addr."]["phone"] = value;
        } else if (name === "S.H.Pho") {
            data["S.H.Addr."]["phone"] = value;
        } else if (name === "P.F.Name") {
            data["P.L.Name"] = this.splitName(value);
        } else if (name === "S.F.Name") {
            data["S.L.Name"] = this.splitName(value);
        }
        this.setState(() => ({
            data
        }));
    }
    splitName(str) {
        let strArr = str.split(" ");
        if (strArr.length >= 2) {
            return strArr[strArr.length - 1];
        } else {
            return "";
        }
    }
    doNext() {
        const { data } = this.state;
        let canNext = true;
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (key === "S.H.Addr.") {
                    canNext = this.verifyAddrValue(data[key]);
                    if (canNext) {
                        continue;
                    }
                } else if (key === "S.Em" || key === "S.W.Pho" || key === "P.F.Name" ||
                    key === "P.L.Name" || key === "P.DOB" || key === "P.SSN.L4" ||
                    key === "P.H.Pho" || key === "P.W.Pho" || key === "P.Em" ||
                    key === "P.F.L.N.I." || key === "P.H.Addr." || key === "P.SEX") {
                    continue;
                }
                if (data[key] === "" || canNext === false) {
                    return false;
                }
            }
        }
        return true;
    }
    verifyAddrValue(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key === "unit" && obj[key] === "") {
                    if (obj["country"] === "US") {
                        continue;
                    }
                }
                if (key === "phone") {
                    continue;
                }
                if (obj[key] === "") {
                    return false;
                }
            }
        }
        return true;
    }
    validator(type, name1, name2) {
        const { data, showMsg } = this.state;
        if (showMsg) {
            const value = name2 ? data[name1][name2] : data[name1];
            if (type === ERR) {
                return value ? false : true;
            } else {
                return value ? "" : "This field is required."
            }
        } else {
            const value = type === ERR ? false : "";
            return value;
        }
    }
    isDisabled() {
        return false
        // const { state } = this.props;
        // if (state === ADD) {
        //     return false;
        // } else if (state === VIEW) {
        //     return true;
        // } else if (state === EDIT) {
        //     return false;
        // }
    }
}

export default PanelSpouse;